export const TemplateArrayHelpers = {
  methods: {
    findPropertyInTemplateList(property, list, userPreferredLanguage) {
      //flatten list, get fields, flatten that list and then find the property
      //in question
      const foundProp = list
        .flat()
        .map(section => section.fields)
        .flat()
        .find(field => field.basicInfoFieldName === property);

      //if we didn't find the prop, we return an empty string.
      if (!foundProp) return '';

      //if our foundProp has a value, we apply the translation to it
      if (foundProp.hasOwnProperty('value'))
        return this.findTranslation(foundProp.value, userPreferredLanguage);

      //in case all else fails, let's default to returning an
      //empty string
      return '';
    },

    findPropertyTypeInTemplateList(type, list, userPreferredLanguage) {
      const foundField = list
        .map(section => section.fields)
        .flat()
        .filter(field => field.type === type)
        .map(foundProp =>
          this.findTranslation(foundProp.value, userPreferredLanguage)
        );

      if (foundField.length > 0) return foundField[0];
      return '';
    },

    findTranslation(object, translation) {
      //check that we got a valid object
      if (typeof object !== 'object' || object === null) return '';

      //Check if object has a defaultLanguage property and if its not equal to an empty string
      if (object[translation]) {
        return object[translation];
      }

      for (const lang in object) {
        if (object[lang]) {
          return object[lang];
        }
      }

      return object[Object.keys(object)[0]];
    },

    //this method is used to render the item's default language if the app defaultLanguage
    //is not available
    findTranslationMultipleOptions(
      object,
      itemDefaultLangueage,
      defaultLanguage
    ) {
      if (typeof object !== 'object' || object === null) return '';

      //check if defaultLanguage is available and return
      if (object[defaultLanguage]) return object[defaultLanguage];

      //check if item defaultLanguage is available and return
      if (object[itemDefaultLangueage]) return object[itemDefaultLangueage];

      return object[Object.keys(object)[0]];
    },

    findShowcaseFirstImage(list, property) {
      const foundProp = list
        .map(section => section.fields)
        .flat()
        .find(field => field.basicInfoFieldName === property);
      return foundProp?.value?.names?.length ? foundProp.value.names[0] : '';
    }
  }
};
